import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { AbstractService } from "src/app/common/services/abstract.service";

const API_PATH = "/api/internal/tracking";

@Injectable({
  providedIn: "root",
})
export class UserTrackingService extends AbstractService {
  private readonly httpClient = inject(HttpClient);

  async track(username: string, feature: string): Promise<void> {
    const params = new HttpParams().appendAll({ username, feature });
    await firstValueFrom(this.httpClient.post(API_PATH, null, { params }));
  }

  async count(params: HttpParams): Promise<Record<string, number> | null> {
    return await this.cancelPrevious(
      "tracking-count",
      this.httpClient.get<Record<string, number>>(API_PATH, { params }),
    );
  }
}
